<template>
    <div>
        <Header />
        <main class="verify-link">
            <h1 class="center">{{ check_status(verify) }}</h1>
            <router-link to="/" class="button bt--edit">
                <span>HOME</span>
            </router-link>
        </main>


    </div>
</template>

<script>
import Header from '@/views/errors/Header';
export default {
    name: 'Authentication',
    props: ['verify'],
    components: { Header },
    methods: {
        check_status(v) {
            console.log(v)
            if (v.status === 200) {
                return this.$t('info_update.email_updated');
            }
            else if (v.status === 422) {
                const msg = v.data.error.error
                console.log(msg)
                switch (msg) {
                    case 'Verification_link_code code has already been verified.':
                        return this.$t('error.already_varify');
                        break
                    case 'Verification_link_code code has expired.':
                        return this.$t('error.expired_code');
                        break
                    case 'Invalid verification code.':
                        return this.$t('error.code_invalid');
                        break;
                    default:
                        return this.$t('error.generic_error', [v.status])
                }
            }
        }
    }
}
</script>
<style scoped>
.verify-link {
    padding: 13em 0;
}

.verify-link .button {
    display: block;
    width: 15rem;
    margin: 5em auto;
}
</style>